/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
    AddTasksDto,
    AddedTasksDto,
    CopyPeriodRequest,
    DeleteTaskDto,
    GetUserPeriodByDateParams,
    InitDataDto,
    PeriodDataDto,
    PinTasksPayload,
    ProblemDetails,
    RegisterTimeHoursPayload,
    RegisterTimePercentPayload,
    RetractTimesheetDto,
    SearchResultDto,
    SubmitTimesheetDto,
    TaskSearchParams,
    ValidationErrorResponse,
    WorkTypeChangeDto,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Api<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * @description Get initial data including the configuration, user and its open periods.
     *
     * @tags Initialization
     * @name GetInitialData
     * @summary Get Initial Data
     * @request GET:/api/v2/initialization/get-initial-data
     * @secure
     * @response `200` `InitDataDto` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    getInitialData = (params: RequestParams = {}) =>
        this.request<InitDataDto, ProblemDetails>({
            path: `/api/v2/initialization/get-initial-data`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Search
     * @name TaskSearch
     * @request GET:/api/v2/search/tasks
     * @secure
     * @response `200` `SearchResultDto` OK
     * @response `400` `ProblemDetails` Bad Request
     */
    taskSearch = (query: TaskSearchParams = {}, params: RequestParams = {}) =>
        this.request<SearchResultDto, ProblemDetails>({
            path: `/api/v2/search/tasks`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Task
     * @name ChangeWorkType
     * @request POST:/api/v2/timesheet/task/change-work-type
     * @secure
     * @response `200` `boolean` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `500` `void` Internal Server Error
     */
    changeWorkType = (body: WorkTypeChangeDto, params: RequestParams = {}) =>
        this.request<boolean, ProblemDetails | void>({
            path: `/api/v2/timesheet/task/change-work-type`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Task
     * @name DeleteTask
     * @request POST:/api/v2/timesheet/task/delete
     * @secure
     * @response `200` `void` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     * @response `500` `void` Internal Server Error
     */
    deleteTask = (body: DeleteTaskDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails | void>({
            path: `/api/v2/timesheet/task/delete`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Tasks
     * @name AddTasks
     * @request POST:/api/v2/timesheet/tasks/add
     * @secure
     * @response `200` `AddedTasksDto` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `500` `void` Internal Server Error
     */
    addTasks = (body: AddTasksDto, params: RequestParams = {}) =>
        this.request<AddedTasksDto, ProblemDetails | void>({
            path: `/api/v2/timesheet/tasks/add`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Tasks
     * @name PinTasks
     * @request POST:/api/v2/timesheet/tasks/set-pinned
     * @secure
     * @response `200` `void` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `500` `void` Internal Server Error
     */
    pinTasks = (body: PinTasksPayload, params: RequestParams = {}) =>
        this.request<void, ProblemDetails | void>({
            path: `/api/v2/timesheet/tasks/set-pinned`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Timesheet
     * @name RegisterTimeHours
     * @request POST:/api/v2/timesheet/register-time-hours
     * @secure
     * @response `200` `void` OK
     * @response `400` `ValidationErrorResponse` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `500` `void` Internal Server Error
     */
    registerTimeHours = (body: RegisterTimeHoursPayload, params: RequestParams = {}) =>
        this.request<void, ValidationErrorResponse | ProblemDetails | void>({
            path: `/api/v2/timesheet/register-time-hours`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Timesheet
     * @name RegisterTimePercent
     * @request POST:/api/v2/timesheet/register-time-percent
     * @secure
     * @response `200` `void` OK
     * @response `400` `ValidationErrorResponse` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `500` `void` Internal Server Error
     */
    registerTimePercent = (body: RegisterTimePercentPayload, params: RequestParams = {}) =>
        this.request<void, ValidationErrorResponse | ProblemDetails | void>({
            path: `/api/v2/timesheet/register-time-percent`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Timesheet
     * @name RetractTimesheet
     * @request POST:/api/v2/timesheet/retract
     * @secure
     * @response `200` `void` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `500` `void` Internal Server Error
     */
    retractTimesheet = (body: RetractTimesheetDto, params: RequestParams = {}) =>
        this.request<void, ProblemDetails | void>({
            path: `/api/v2/timesheet/retract`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * No description
     *
     * @tags Timesheet
     * @name SubmitTimesheet
     * @request POST:/api/v2/timesheet/submit
     * @secure
     * @response `200` `void` OK
     * @response `400` `ValidationErrorResponse` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `500` `void` Internal Server Error
     */
    submitTimesheet = (body: SubmitTimesheetDto, params: RequestParams = {}) =>
        this.request<void, ValidationErrorResponse | ProblemDetails | void>({
            path: `/api/v2/timesheet/submit`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            ...params,
        });
    /**
     * @description Copies time entries from one user period to another using day-offset mapping. Both periods must belong to the authenticated user, span the same number of days, start on the same day of the week, and the target period must be empty. Returns the updated target period in the same format as Get User Period By Date.
     *
     * @tags Userperiod
     * @name CopyUserPeriod
     * @summary Copy User Period
     * @request POST:/api/v2/users/userperiod/copy
     * @secure
     * @response `200` `PeriodDataDto` OK
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `500` `void` Internal Server Error
     */
    copyUserPeriod = (body: CopyPeriodRequest, params: RequestParams = {}) =>
        this.request<PeriodDataDto, ProblemDetails | void>({
            path: `/api/v2/users/userperiod/copy`,
            method: 'POST',
            body: body,
            secure: true,
            type: 'application/json',
            format: 'json',
            ...params,
        });
    /**
     * @description Retrieves timesheet data for the period containing the specified date. Returns the same data structure as the initialization endpoint for consistency.
     *
     * @tags Userperiod
     * @name GetUserPeriodByDate
     * @summary Get User Period By Date
     * @request GET:/api/v2/users/userperiod/get-by-date
     * @secure
     * @response `200` `PeriodDataDto` OK
     * @response `401` `ProblemDetails` Unauthorized
     */
    getUserPeriodByDate = (query: GetUserPeriodByDateParams = {}, params: RequestParams = {}) =>
        this.request<PeriodDataDto, ProblemDetails>({
            path: `/api/v2/users/userperiod/get-by-date`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
        });
}
